import { useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import "./ChoosePracticedSport.scss";

const ChoosePracticedSport: React.FC = () => {
  const [isActive, setIsActive] = useState(0);
  const navigate = useNavigate();

  const {
    control,
    handleSubmit,
    setValue,
    formState: { errors },
    register,
  } = useForm({
    defaultValues: {
      selectedAccount: -1,
    },
  });

  const onSubmit = (data: any) => {
    console.log(data);
  };

  return (
    <>
      {/* <div className="sign-up-sports__caption">
        <p className="sign-up-sports__caption-title">Practiced sports</p>
        <p className="sign-up-sports__caption-subtitle">
          Select which sport you are mainly involved with.
        </p>
      </div>

      <form className="sign-up-sports__input" onSubmit={handleSubmit(onSubmit)}>
        <div className="sign-up-sports__buttons">
          {sportsList.sports.map((value, index) => {
            return (
              <Button
                className={
                  isActive === index
                    ? "btn big-button active"
                    : "btn big-button "
                }
                action={() => {
                  setIsActive(index);
                  setValue("selectedAccount", index);
                }}
                key={index}
              >
                <div className="d-flex column center">
                  <img
                    src={require(`../../../assets/icons/${value.name}.png`)}
                    alt=""
                    className="sport-img"
                  />
                  {value.sport}
                </div>
              </Button>
            );
          })}
        </div>

        <Button
          className="btn btn-primary "
          action={() => navigate("/sign-up/other-sports")}
        >
          Next
        </Button>
      </form> */}
    </>
  );
};

export default ChoosePracticedSport;
